export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13630.c3c3c08f.jpg";